/* Wave2Wear shoppable UGC gallery — open photo in a lightbox with IG credit + product tag dots. */
(function () {
  var lb = document.querySelector('[data-w2w-ugc-lightbox]');
  if (!lb) return;
  var img = lb.querySelector('.w2w-ugc-lb__img');
  var dotsWrap = lb.querySelector('.w2w-ugc-lb__dots');
  var cred = lb.querySelector('.w2w-ugc-lb__cred');
  var credAva = lb.querySelector('.w2w-ugc-lb__ava');
  var credName = lb.querySelector('.w2w-ugc-lb__uname');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function open(item) {
    img.src = item.getAttribute('data-full');
    // IG credit
    var user = item.getAttribute('data-user') || '';
    var ig = item.getAttribute('data-ig') || '';
    var ava = item.getAttribute('data-ava') || '';
    if (user) {
      cred.hidden = false;
      cred.href = ig || '#';
      credName.textContent = user;
      if (ava) { credAva.src = ava; credAva.style.display = ''; } else { credAva.style.display = 'none'; }
    } else { cred.hidden = true; }
    // product tag dots
    var data = [];
    var s = item.querySelector('.w2w-ugc__tags');
    if (s) { try { data = JSON.parse(s.textContent || '[]'); } catch (e) { data = []; } }
    dotsWrap.innerHTML = '';
    data.forEach(function (t) {
      var a = document.createElement('a');
      a.className = 'w2w-ugc-dot';
      a.href = t.url || '#';
      a.style.left = (t.x != null ? t.x : 50) + '%';
      a.style.top = (t.y != null ? t.y : 50) + '%';
      a.innerHTML =
        '<span class="w2w-ugc-dot__pulse"></span>' +
        '<span class="w2w-ugc-dot__card">' +
        (t.img ? '<img src="' + esc(t.img) + '" alt="">' : '') +
        '<span class="w2w-ugc-dot__meta">' +
        '<span class="w2w-ugc-dot__t">' + esc(t.title) + '</span>' +
        '<span class="w2w-ugc-dot__p">' + esc(t.price) + '</span>' +
        '<span class="w2w-ugc-dot__shop">Shop &rarr;</span>' +
        '</span></span>';
      dotsWrap.appendChild(a);
    });
    lb.hidden = false;
    lb.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { lb.classList.add('is-open'); });
  }

  function close() {
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { lb.hidden = true; lb.setAttribute('aria-hidden', 'true'); img.src = ''; dotsWrap.innerHTML = ''; }, 250);
  }

  document.querySelectorAll('.w2w-ugc__item').forEach(function (item) {
    item.addEventListener('click', function (e) {
      if (e.target.closest('a')) return; // let the IG credit link work normally
      open(item);
    });
    item.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(item); } });
  });
  lb.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
})();
